import React from "react";

const AddUnitOutlinedIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3432_501"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3432_501)">
        <path
          d="M1.5 20.5V11.25L8 6.6155L14.6443 11.3558C14.4686 11.5314 14.2936 11.7113 14.1193 11.8953C13.9449 12.0793 13.7699 12.259 13.5943 12.4345L8 8.46925L3 12V19H5.3655V14.25H10.6345V20.5H9.13475V15.75H6.86525V20.5H1.5ZM22.5 3.5V12.8463C22.2807 12.6296 22.0477 12.4357 21.801 12.2645C21.5542 12.0933 21.2872 11.9385 21 11.8V5H11.6923V6.79425L10.1923 5.70975V3.5H22.5ZM17.1155 8.8845H18.8845V7.1155H17.1155V8.8845ZM18 22.5C16.7513 22.5 15.6892 22.0622 14.8135 21.1865C13.9378 20.3108 13.5 19.2487 13.5 18C13.5 16.7513 13.9378 15.6892 14.8135 14.8135C15.6892 13.9378 16.7513 13.5 18 13.5C19.2487 13.5 20.3108 13.9378 21.1865 14.8135C22.0622 15.6892 22.5 16.7513 22.5 18C22.5 19.2487 22.0622 20.3108 21.1865 21.1865C20.3108 22.0622 19.2487 22.5 18 22.5ZM17.5578 20.9423H18.4423V18.4423H20.9423V17.5577H18.4423V15.0577H17.5578V17.5577H15.0577V18.4423H17.5578V20.9423Z"
          fill="#D5ECFD"
        />
      </g>
    </svg>
  );
};

export default AddUnitOutlinedIcon;
